import React from "react";
import ContentLoader from "react-content-loader";

function SliderSceleton() {
  return (
    <div className="w-100 h-100 p-2">
      <ContentLoader
        speed={2}
        width="100%"
        height="100%"
        viewBox="0 0 400 300"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        preserveAspectRatio="none"
        style={{ width: "100%", height: "100%", borderRadius: "12px" }}
      >
        <rect x="0" y="0" rx="8" ry="8" width="100%" height="70%" />

        <rect x="0" y="75%" rx="4" ry="4" width="60%" height="12%" />
        <rect x="0" y="90%" rx="4" ry="4" width="30%" height="8%" />
      </ContentLoader>
    </div>
  );
}

export default SliderSceleton;
